import script from './SpinnerBars.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;_vm._self._c||_h;return _vm._m(0)};
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-bars"},[_c('div',{staticClass:"spinner-bars__el a"}),_vm._v(" "),_c('div',{staticClass:"spinner-bars__el b"}),_vm._v(" "),_c('div',{staticClass:"spinner-bars__el c"})])}];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1d466705_0", { source: ".spinner-bars[data-v-1d466705]{margin:0 auto;width:20px;height:20px;color:currentColor;white-space:nowrap;line-height:20px;transition:all .2s ease;display:flex;justify-content:space-between}.spinner-bars__el[data-v-1d466705]{background-color:currentColor;height:100%;width:4px;display:inline-block;border-radius:2px;animation:sk-stretchdelay-data-v-1d466705 1.2s infinite ease-in-out}.spinner-bars__el.b[data-v-1d466705]{animation-delay:-1.1s}.spinner-bars__el.c[data-v-1d466705]{animation-delay:-1s}@keyframes sk-stretchdelay-data-v-1d466705{0%{transform:scaleY(.25)}100%,40%{transform:scaleY(.5)}20%,80%{transform:scaleY(1)}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-1d466705";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
